/**
* @author vishwadeep.kapoor
* ValidationErrors
*
*/

import React from 'react';
import { shape, string } from 'prop-types';
import styled from 'styled-components';

const Validator = styled.div`
  text-align:left;
  padding:5px 0px;
span{
  font-size:12px;
  color:${(props) => props.theme.primaryColor};
}

`;

const ValidationErrors = (validators, fieldName) => {
  const validator = validators[fieldName];
  const result = '';
  if (validator && !validator.valid) {
    const errors = validator.errors.map((info, index) => { // eslint-disable-line
      return <span className="error" key={index}>{info}</span>;
    });

    return (
      <Validator>
        {errors}
      </Validator>
    );
  }
  return result;
};

ValidationErrors.propTypes = {
  validators: shape({}),
  fieldName: string,
};

ValidationErrors.defaultProps = {

};

export default ValidationErrors;



// WEBPACK FOOTER //
// client/components/ValidationErrors/index.js